const TIPO_EMISION_ONLINE = 'Automática online';
const TIPO_EMISION_OFFLINE = 'Requiere envío de documentación offline';
const EXTENSIBLE_SEGUN_INGRESO = 'Extensible según tu ingreso';
const VIP_AEROPUERTOS = 'Acceso a salas VIP en aeropuertos';
const APROBACION_INMEDIATA = 'Aprobación inmediata y envío a domicilio';
const COMPRAS_REGIONALES = 'Regionales';
const COMPRAS_INTERNACIONALES = 'Internacionales';
const MILLAS_CADA_1 = '1 dólar = 1 milla';
const MILLAS_CADA_2 = '2 dólares = 1 milla';
const VALOR_PUNTOS_BENEFITS = '1 dólar = 1 Benefit';
const SOLO_EN_SUCURSALES = 'Sólo en sucursales';
const REQUIERE_DOCUMENTACION = 'Requieren documentación y envío a domicilio';

const badges = {
  REGIONAL: {
    title: 'Regional',
    foreground: '#000000',
    background: '#eaeaea',
  },
  INTERNACIONAL: {
    title: 'Internacional',
    foreground: '#ffffff',
    background: '#ec7404',
  },
  ORO: {
    title: 'Oro',
    foreground: '#ffffff',
    background: '#ba8d34',
  },
  PLATINUM: {
    title: 'Platinum',
    foreground: '#ffffff',
    background: '#757575',
  },
  INFINITE: {
    title: 'Infinite',
    foreground: '#ffffff',
    background: '#252220',
  },
};

const cards = [
  {
    id: 1,
    title: 'Volar',
    label: 'Volar',
    color: '#ec7000',
    logo: require('../../assets/logo-volar.png'),
    thumb: require('../../assets/logo-group-volar.png'),
    benefits: ['Acumulación de millas', 'Canjes de productos y servicios', 'Beneficios exclusivos'],
    types: [
      {
        id: 1,
        brand: 'Visa',
        badge: badges.REGIONAL,
        image: require('../../assets/visa/volar/volar-regional.png'),
        thumbnail: require('../../assets/visa-thumbs/volar/volar-regional.png'),
        infoText: APROBACION_INMEDIATA,
        infoIcon: require('../../assets/icon-entrega.svg'),
        creditInfo: EXTENSIBLE_SEGUN_INGRESO,
        features: {
          creditoMinimo: 25000,
          compras: COMPRAS_REGIONALES,
          // ingresoMinimo: 23000,
          costo: 414,
          puntos: MILLAS_CADA_1,
          tipoEmision: TIPO_EMISION_ONLINE,
          vip: null,
        },
      },
      {
        id: 2,
        brand: 'Visa',
        badge: badges.INTERNACIONAL,
        image: require('../../assets/visa/volar/volar-internacional.png'),
        thumbnail: require('../../assets/visa-thumbs/volar/volar-internacional.png'),
        infoText: APROBACION_INMEDIATA,
        infoIcon: require('../../assets/icon-entrega.svg'),
        creditInfo: EXTENSIBLE_SEGUN_INGRESO,
        features: {
          creditoMinimo: 25000,
          compras: COMPRAS_INTERNACIONALES,
          // ingresoMinimo: 23000,
          costo: 864,
          puntos: MILLAS_CADA_1,
          tipoEmision: TIPO_EMISION_ONLINE,
          vip: null,
        },
      },
      {
        id: 3,
        brand: 'Visa',
        badge: badges.ORO,
        image: require('../../assets/visa/volar/volar-gold.png'),
        thumbnail: require('../../assets/visa-thumbs/volar/volar-gold.png'),
        infoText: APROBACION_INMEDIATA,
        infoIcon: require('../../assets/icon-entrega.svg'),
        creditInfo: EXTENSIBLE_SEGUN_INGRESO,
        features: {
          creditoMinimo: 60000,
          compras: COMPRAS_INTERNACIONALES,
          ingresoMinimo: 30000,
          costo: 961,
          puntos: MILLAS_CADA_1,
          tipoEmision: TIPO_EMISION_ONLINE,
          vip: null,
        },
      },
      {
        id: 4,
        brand: 'Visa',
        badge: badges.PLATINUM,
        image: require('../../assets/visa/volar/volar-platinum.png'),
        thumbnail: require('../../assets/visa-thumbs/volar/volar-platinum.png'),
        infoText: REQUIERE_DOCUMENTACION,
        infoIcon: require('../../assets/icon-documentacion.svg'),
        creditInfo: 'Envío a domicilio después de ser aprobada.',
        features: {
          creditoMinimo: 120000,
          compras: COMPRAS_INTERNACIONALES,
          ingresoMinimo: 60000,
          costo: 1058,
          puntos: MILLAS_CADA_1,
          tipoEmision: TIPO_EMISION_OFFLINE,
          vip: VIP_AEROPUERTOS,
        },
      },
      {
        id: 5,
        brand: 'Visa',
        badge: badges.INFINITE,
        image: require('../../assets/visa/volar/volar-infinite.png'),
        thumbnail: require('../../assets/visa-thumbs/volar/volar-infinite.png'),
        infoText: SOLO_EN_SUCURSALES,
        infoIcon: require('../../assets/icon-sucursal.svg'),
        // creditInfo: EXTENSIBLE_SEGUN_INGRESO,
        features: {
          creditoMinimo: null,
          compras: COMPRAS_INTERNACIONALES,
          ingresoMinimo: null,
          costo: 1454,
          puntos: MILLAS_CADA_1,
          tipoEmision: TIPO_EMISION_OFFLINE,
          vip: VIP_AEROPUERTOS,
        },
      },
    ],
  },
  {
    id: 2,
    title: 'LATAM Pass',
    label: 'LATAM Pass',
    color: '#1e0098',
    logo: require('../../assets/logo-latam.svg'),
    thumb: require('../../assets/logo-group-latam.png'),
    benefits: [
      // 'Acumulación de millas para Millas para vuelos en LATAM y compañías asociadas.',
      'Millas para vuelos en LATAM y compañías asociadas',
      'Upgrade de categoría al volar en Latam',
    ],
    types: [
      {
        id: 1,
        brand: 'Visa',
        badge: badges.REGIONAL,
        image: require('../../assets/visa/latam/latam-regional.png'),
        thumbnail: require('../../assets/visa-thumbs/latam/latam-regional.png'),
        infoText: APROBACION_INMEDIATA,
        infoIcon: require('../../assets/icon-entrega.svg'),
        creditInfo: EXTENSIBLE_SEGUN_INGRESO,
        features: {
          creditoMinimo: 25000,
          compras: COMPRAS_REGIONALES,
          // ingresoMinimo: 23000,
          costo: 414,
          puntos: MILLAS_CADA_2,
          tipoEmision: TIPO_EMISION_ONLINE,
          vip: null,
        },
      },
      {
        id: 2,
        brand: 'Visa',
        badge: badges.INTERNACIONAL,
        image: require('../../assets/visa/latam/latam-internacional.png'),
        thumbnail: require('../../assets/visa-thumbs/latam/latam-internacional.png'),
        infoText: APROBACION_INMEDIATA,
        infoIcon: require('../../assets/icon-entrega.svg'),
        creditInfo: EXTENSIBLE_SEGUN_INGRESO,
        features: {
          creditoMinimo: 25000,
          compras: COMPRAS_INTERNACIONALES,
          // ingresoMinimo: 23000,
          costo: 864,
          puntos: MILLAS_CADA_2,
          tipoEmision: TIPO_EMISION_ONLINE,
          vip: null,
        },
      },
      {
        id: 3,
        brand: 'Visa',
        badge: badges.ORO,
        image: require('../../assets/visa/latam/latam-gold.png'),
        thumbnail: require('../../assets/visa-thumbs/latam/latam-gold.png'),
        infoText: APROBACION_INMEDIATA,
        infoIcon: require('../../assets/icon-entrega.svg'),
        creditInfo: EXTENSIBLE_SEGUN_INGRESO,
        features: {
          creditoMinimo: 60000,
          compras: COMPRAS_INTERNACIONALES,
          ingresoMinimo: 30000,
          costo: 961,
          puntos: MILLAS_CADA_1,
          tipoEmision: TIPO_EMISION_ONLINE,
          vip: null,
        },
      },
      {
        id: 4,
        brand: 'Visa',
        badge: badges.PLATINUM,
        image: require('../../assets/visa/latam/latam-platinum.png'),
        thumbnail: require('../../assets/visa-thumbs/latam/latam-platinum.png'),
        infoText: REQUIERE_DOCUMENTACION,
        infoIcon: require('../../assets/icon-documentacion.svg'),
        creditInfo: EXTENSIBLE_SEGUN_INGRESO,
        features: {
          creditoMinimo: 120000,
          compras: COMPRAS_INTERNACIONALES,
          ingresoMinimo: 60000,
          costo: 1058,
          puntos: MILLAS_CADA_1,
          tipoEmision: TIPO_EMISION_OFFLINE,
          vip: VIP_AEROPUERTOS,
        },
      },
      {
        id: 5,
        brand: 'Visa',
        badge: badges.INFINITE,
        image: require('../../assets/visa/latam/latam-infinite.png'),
        thumbnail: require('../../assets/visa-thumbs/latam/latam-infinite.png'),
        infoText: SOLO_EN_SUCURSALES,
        infoIcon: require('../../assets/icon-sucursal.svg'),
        creditInfo: EXTENSIBLE_SEGUN_INGRESO,
        features: {
          // creditoMinimo: 25000,
          compras: COMPRAS_INTERNACIONALES,
          ingresoMinimo: 1454,
          costo: 864,
          puntos: MILLAS_CADA_1,
          tipoEmision: TIPO_EMISION_OFFLINE,
          vip: VIP_AEROPUERTOS,
        },
      },
    ],
  },
  {
    id: 3,
    title: 'On de Punta Carretas',
    label: 'On',
    color: '#e6e6e6',
    logo: require('../../assets/logo-on.png'),
    thumb: require('../../assets/logo-group-on.png'),
    benefits: [
      'Descuentos en los locales del Punta Carretas Shopping',
      'Puntos acumulables y canjeables por premios en Punta Carretas Shopping',
    ],
    types: [
      {
        id: 1,
        brand: 'Visa',
        badge: badges.REGIONAL,
        image: require('../../assets/visa/on/on-regional.png'),
        thumbnail: require('../../assets/visa-thumbs/on/on-regional.png'),
        infoText: APROBACION_INMEDIATA,
        infoIcon: require('../../assets/icon-sucursal.svg'),
        creditInfo: EXTENSIBLE_SEGUN_INGRESO,
        features: {
          creditoMinimo: 25000,
          compras: COMPRAS_REGIONALES,
          // ingresoMinimo: 23000,
          costo: 414,
          puntos: '10 dólares = 1 dot',
          tipoEmision: TIPO_EMISION_ONLINE,
          vip: null,
        },
      },
      {
        id: 2,
        brand: 'Visa',
        badge: badges.INTERNACIONAL,
        image: require('../../assets/visa/on/on-internacional.png'),
        thumbnail: require('../../assets/visa-thumbs/on/on-internacional.png'),
        infoText: APROBACION_INMEDIATA,
        infoIcon: require('../../assets/icon-sucursal.svg'),
        creditInfo: EXTENSIBLE_SEGUN_INGRESO,
        features: {
          creditoMinimo: 25000,
          compras: COMPRAS_INTERNACIONALES,
          // ingresoMinimo: 23000,
          costo: 864,
          puntos: '10 dólares = 1 dot',
          tipoEmision: TIPO_EMISION_ONLINE,
          vip: null,
        },
      },
      {
        id: 3,
        brand: 'Visa',
        badge: badges.ORO,
        image: require('../../assets/visa/on/on-gold.png'),
        thumbnail: require('../../assets/visa-thumbs/on/on-gold.png'),
        infoText: APROBACION_INMEDIATA,
        infoIcon: require('../../assets/icon-sucursal.svg'),
        creditInfo: EXTENSIBLE_SEGUN_INGRESO,
        features: {
          creditoMinimo: 60000,
          compras: COMPRAS_INTERNACIONALES,
          ingresoMinimo: 30000,
          costo: 961,
          puntos: '10 dólares = 1 dot',
          tipoEmision: TIPO_EMISION_ONLINE,
          vip: null,
        },
      },
      {
        id: 4,
        brand: 'Visa',
        badge: badges.PLATINUM,
        image: require('../../assets/visa/on/on-platinum.png'),
        thumbnail: require('../../assets/visa-thumbs/on/on-platinum.png'),
        infoText: REQUIERE_DOCUMENTACION,
        infoIcon: require('../../assets/icon-documentacion.svg'),
        creditInfo: EXTENSIBLE_SEGUN_INGRESO,
        features: {
          creditoMinimo: 120000,
          compras: COMPRAS_INTERNACIONALES,
          ingresoMinimo: 60000,
          costo: 1058,
          puntos: '10 dólares = 1 dot',
          tipoEmision: TIPO_EMISION_OFFLINE,
          vip: VIP_AEROPUERTOS,
        },
      },
      {
        id: 5,
        brand: 'Visa',
        badge: badges.INFINITE,
        image: require('../../assets/visa/on/on-infinite.png'),
        thumbnail: require('../../assets/visa-thumbs/on/on-infinite.png'),
        infoText: SOLO_EN_SUCURSALES,
        infoIcon: require('../../assets/icon-sucursal.svg'),
        creditInfo: EXTENSIBLE_SEGUN_INGRESO,
        features: {
          // creditoMinimo: 25000,
          compras: COMPRAS_INTERNACIONALES,
          ingresoMinimo: 23000,
          costo: 1454,
          puntos: '10 dólares = 1 dot',
          tipoEmision: TIPO_EMISION_OFFLINE,
          vip: VIP_AEROPUERTOS,
        },
      },
    ],
  },
  {
    id: 4,
    title: 'Benefits de Portones',
    label: 'Benefits',
    color: '#ec2d62',
    logo: require('../../assets/logo-portones.png'),
    thumb: require('../../assets/logo-group-portones.png'),
    benefits: [
      'Descuentos en los locales del Portones Shopping',
      'Puntos acumulables y canjeables por vales de compra y premios en Portones Shopping',
    ],
    types: [
      {
        id: 1,
        brand: 'Visa',
        badge: badges.REGIONAL,
        image: require('../../assets/visa/benefits/benefits-regional.png'),
        thumbnail: require('../../assets/visa-thumbs/benefits/benefits-regional.png'),
        infoText: APROBACION_INMEDIATA,
        infoIcon: require('../../assets/icon-entrega.svg'),
        creditInfo: EXTENSIBLE_SEGUN_INGRESO,
        features: {
          creditoMinimo: 25000,
          compras: COMPRAS_INTERNACIONALES,
          // ingresoMinimo: 23000,
          costo: 414,
          puntos: VALOR_PUNTOS_BENEFITS,
          tipoEmision: TIPO_EMISION_ONLINE,
          vip: null,
        },
      },
      {
        id: 2,
        brand: 'Visa',
        badge: badges.INTERNACIONAL,
        image: require('../../assets/visa/benefits/benefits-internacional.png'),
        thumbnail: require('../../assets/visa-thumbs/benefits/benefits-internacional.png'),
        infoText: APROBACION_INMEDIATA,
        infoIcon: require('../../assets/icon-entrega.svg'),
        creditInfo: EXTENSIBLE_SEGUN_INGRESO,
        features: {
          creditoMinimo: 25000,
          compras: COMPRAS_INTERNACIONALES,
          // ingresoMinimo: 23000,
          costo: 864,
          puntos: VALOR_PUNTOS_BENEFITS,
          tipoEmision: TIPO_EMISION_ONLINE,
          vip: null,
        },
      },
      {
        id: 3,
        brand: 'Visa',
        badge: badges.ORO,
        image: require('../../assets/visa/benefits/benefits-gold.png'),
        thumbnail: require('../../assets/visa-thumbs/benefits/benefits-gold.png'),
        infoText: APROBACION_INMEDIATA,
        infoIcon: require('../../assets/icon-entrega.svg'),
        creditInfo: EXTENSIBLE_SEGUN_INGRESO,
        features: {
          creditoMinimo: 60000,
          compras: COMPRAS_INTERNACIONALES,
          ingresoMinimo: 30000,
          costo: 961,
          puntos: VALOR_PUNTOS_BENEFITS,
          tipoEmision: TIPO_EMISION_ONLINE,
          vip: null,
        },
      },
      {
        id: 4,
        brand: 'Visa',
        badge: badges.PLATINUM,
        image: require('../../assets/visa/benefits/benefits-platinum.png'),
        thumbnail: require('../../assets/visa-thumbs/benefits/benefits-platinum.png'),
        infoText: REQUIERE_DOCUMENTACION,
        infoIcon: require('../../assets/icon-documentacion.svg'),
        creditInfo: EXTENSIBLE_SEGUN_INGRESO,
        features: {
          creditoMinimo: 120000,
          compras: COMPRAS_INTERNACIONALES,
          ingresoMinimo: 60000,
          costo: 1058,
          puntos: VALOR_PUNTOS_BENEFITS,
          tipoEmision: TIPO_EMISION_OFFLINE,
          vip: null,
        },
      },
      // {
      //   id: 5,
      //   brand: 'Visa',
      //   badge: badges.INFINITE,
      //   image: require('../../assets/visa/benefits/benefits-infinite.png'),
      //   thumbnail: require('../../assets/visa-thumbs/benefits/benefits-infinite.png'),
      //   infoText: SOLO_EN_SUCURSALES,
      //   infoIcon: require('../../assets/icon-sucursal.svg'),
      //   creditInfo: EXTENSIBLE_SEGUN_INGRESO,
      //   features: {
      //     creditoMinimo: 25000,
      //     compras: COMPRAS_INTERNACIONALES,
      //     ingresoMinimo: 23000,
      //     costo: 864,
      //     puntos: VALOR_PUNTOS_BENEFITS,
      //     tipoEmision: TIPO_EMISION_ONLINE,
      //     vip: null,
      //   },
      // },
    ],
  },
];

export default cards;
